export const REQUEST_EXISTANT_CLAIMS_FOR_LAWYER: string =
  'REQUEST_EXISTANT_CLAIMS_FOR_LAWYER';
